import { useRouter } from 'next/router'

import { IUL_LP_URLS } from '@/constants'

export const useIsIulPage = () => {
  const { asPath } = useRouter()

  const pathWithoutQuery = asPath.split('?')[0]
  const isIulPage = IUL_LP_URLS.includes(pathWithoutQuery)

  return isIulPage
}
